import * as React from 'react';
import { convertIcon } from '../components/Icon';

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM12 7.4099C12 7.17156 12.1682 6.96635 12.4019 6.91961L16.4019 6.11961C16.7113 6.05773 17 6.29438 17 6.6099V8.5901C17 8.82844 16.8318 9.03365 16.5981 9.08039L14 9.6V15C14 16.6569 12.6569 18 11 18C9.34315 18 8 16.6569 8 15C8 13.3431 9.34315 12 11 12C11.3506 12 11.6872 12.0602 12 12.1707V7.4099Z",
    fill: "currentColor"
  }));
}

const IconComponent = convertIcon(SvgComponent, 'song');
export default IconComponent;